import { render, staticRenderFns } from "./AttachmentViewer.vue?vue&type=template&id=6243ed6c&scoped=true&"
import script from "./AttachmentViewer.vue?vue&type=script&lang=js&"
export * from "./AttachmentViewer.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentViewer.vue?vue&type=style&index=0&id=6243ed6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6243ed6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VChip,VDialog})
